import React, { useState } from 'react';
import styles from './Map.module.css';

const SiteMap = () => {
  const [isEarringsOpen, setIsEarringsOpen] = useState(false);
  const [isRingsOpen, setIsRingsOpen] = useState(false);

  const categories = [
    { id: 'chains', label: 'שרשראות' },
    { id: 'bracelets', label: 'צמידים' },
    { 
      id: 'earrings', 
      label: 'עגילים',
      hasSubcategories: true,
      subcategories: [
        { id: 'earrings-studs', label: 'עגילי סטאד' },
        { id: 'earrings-hoops', label: 'עגילי חישוק' },
        { id: 'earrings-drop', label: 'עגילים תלויים' },
        { id: 'earrings-chain', label: 'עגילי שרשרת' },
        { id: 'earrings-special', label: 'עיצובים מיוחדים' }
      ]
    },
    { 
      id: 'rings', 
      label: 'טבעות',
      hasSubcategories: true,
      subcategories: [
        { id: 'rings-regular', label: 'טבעות' },
        { id: 'rings-zeret', label: 'טבעות זרת' }
      ]
    },
    { id: 'eyebrows', label: 'עיצוב גבות' },
    { id: 'lashes', label: 'הדבקת ריסים' },
    { id: 'makeup', label: 'איפור כלות וערב' },
    { id: 'permanent-makeup', label: 'איפור קבוע' },
    { id: 'spray-tan', label: 'שיזוף בהתזה' }
  ];

  const handleCategoryClick = (categoryId) => {
    if (categoryId === 'earrings') {
      // רק פותח/סגור את התת-קטגוריות של עגילים, בלי גלילה
      setIsEarringsOpen(!isEarringsOpen);
    } else if (categoryId === 'rings') {
      // רק פותח/סגור את התת-קטגוריות של טבעות, בלי גלילה
      setIsRingsOpen(!isRingsOpen);
    } else {
      // כל השאר - גלילה רגילה
      const element = document.getElementById(categoryId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handleSubcategoryClick = (categoryId, parentId) => {
    // גלילה לקטגוריה האב
    const element = document.getElementById(parentId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
    // אירוע מותאם אישית לפתיחת הקטגוריה הספציפית
    setTimeout(() => {
      const eventName = parentId === 'earrings' ? 'openEarringCategory' : 'openRingCategory';
      const event = new CustomEvent(eventName, { 
        detail: { categoryId } 
      });
      window.dispatchEvent(event);
    }, 500);
  };

  return (
    <div className={styles.siteMapContainer}>
      <div className={styles.content}>
        <h2 className={styles.title}>למקרה שפספסת..</h2>
        <p className={styles.description}>לחצי על הקטגוריה ותגיעי ישירות אליה</p>
        
        <div className={styles.categoriesList}>
          {categories.map((category, index) => (
            <React.Fragment key={category.id}>
              <button
                className={`${styles.categoryItem} ${
                  category.hasSubcategories && 
                  ((category.id === 'earrings' && isEarringsOpen) || (category.id === 'rings' && isRingsOpen)) 
                    ? styles.categoryItemOpen 
                    : ''
                }`}
                onClick={() => handleCategoryClick(category.id)}
                aria-label={`עבור לקטגוריה ${category.label}`}
              >
                {category.label}
                {category.hasSubcategories && (
                  <span className={`${styles.arrow} ${
                    (category.id === 'earrings' && isEarringsOpen) || 
                    (category.id === 'rings' && isRingsOpen) 
                      ? styles.arrowOpen 
                      : ''
                  }`}>
                    ▼
                  </span>
                )}
              </button>
              
              {/* תת-קטגוריות עגילים */}
              {category.id === 'earrings' && category.hasSubcategories && isEarringsOpen && (
                <div className={styles.subcategoriesContainer}>
                  {category.subcategories.map((subcategory, subIndex) => (
                    <React.Fragment key={subcategory.id}>
                      <button
                        className={styles.subcategoryItem}
                        onClick={() => handleSubcategoryClick(subcategory.id, 'earrings')}
                        aria-label={`עבור ל${subcategory.label}`}
                      >
                        {subcategory.label}
                      </button>
                      {subIndex < category.subcategories.length - 1 && (
                        <div className={styles.subDivider} />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
              
              {/* תת-קטגוריות טבעות */}
              {category.id === 'rings' && category.hasSubcategories && isRingsOpen && (
                <div className={styles.subcategoriesContainer}>
                  {category.subcategories.map((subcategory, subIndex) => (
                    <React.Fragment key={subcategory.id}>
                      <button
                        className={styles.subcategoryItem}
                        onClick={() => handleSubcategoryClick(subcategory.id, 'rings')}
                        aria-label={`עבור ל${subcategory.label}`}
                      >
                        {subcategory.label}
                      </button>
                      {subIndex < category.subcategories.length - 1 && (
                        <div className={styles.subDivider} />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
              
              {index < categories.length - 1 && <div className={styles.divider} />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SiteMap;